class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.config = {
      dom: {
        cart_items: 'cart-items',
        cart_drawer_items: 'cart-drawer-items',
        cart_item_modal: 'cartItemModal',
        cart_item: 'js-cart-item',
        cart_custom_artwork: 'js-custom-artwork',
        setup_fee: 'js-setup-fee',
      },
    };

    this.addEventListener('click', async (event) => {
      event.preventDefault();
      const element = event.target;
      const parentElement = element.closest(`.${this.config.dom.cart_item}`);
      // Check for custom artwork item
      const isCustomArtwork = !!parentElement?.dataset.customArtwork;
      const $itemModal = document.getElementById(`${this.config.dom.cart_item_modal}-${this.dataset.index}`);
      const cartItems = this.closest(this.config.dom.cart_items)
        || this.closest(this.config.dom.cart_drawer_items);
      // function to get clean filename
      const cleanFilename = (artwork) => {
        if (!artwork) return '';
        const FILE_NAME_REGEX = /^(.+?)-/g;
        const filename = artwork?.split('/')?.pop();
        const artworkFilename = filename?.replace(FILE_NAME_REGEX, '');
        return artworkFilename;
      };
      const dieSetupFeeId = SDG?.Data?.dieSetupFeeProduct;
      let dieSetupItemKey = null;
      let deleteSetupFee = false;
      const artworksData = [];

      if (!cartItems || !cartItems?.updateQuantity) {
        console.error('Cart items or updateQuantity function not found.');
        return;
      }

      // For Custom Artwork
      // We need to check if only one custom artwork item left
      // then proceed to remove die and keep if multiple custom artwork items using same artwork
      if (isCustomArtwork) {
        // const artworkToRemove = cleanFilename(parentElement?.dataset.customArtwork);
        const itemKey = parentElement?.dataset.itemKey;

        // Get all items in cart
        const customArtworkItems = cartItems?.querySelectorAll(`.${this.config.dom.cart_custom_artwork}`);
        // Get all die setup fee items in cart
        // eslint-disable-next-line max-len
        const dieSetupItem = cartItems.querySelector(`.${this.config.dom.setup_fee}`);

        // Create array for all custom artwork filenames in cart
        [...customArtworkItems].forEach((item) => {
          const customArtwork = cleanFilename(item?.dataset.customArtwork);
          if (!artworksData.includes(customArtwork) && !item.dataset.itemKey.includes(itemKey)) {
            artworksData.push(cleanFilename(item?.dataset.customArtwork));
          }
        });

        // set die setup item key for updating item in cart
        dieSetupItemKey = dieSetupItem?.dataset.itemKey;

        // When only one custom artwork item left, remove die setup fee
        if (artworksData.length === 0) {
          deleteSetupFee = true;
        }
      }

      const handleCustomArtwork = async () => {
        // Disable checkout button
        cartItems?.disableCheckoutButton();

        if (deleteSetupFee) {
          // No custom artwork items left, remove die setup fee
          setTimeout(async () => {
            await cartItems?.updateQuantity(dieSetupItemKey, 0);
            cartItems?.enableCheckoutButton();
          }, 1000); // Timeout to make sure product is removed before removing setup fee
        } else {
          // Custom artwork items left, update properties with new custom artwork items
          const properties = artworksData?.reduce((acc, artwork, index) => {
            acc[`Custom Artwork ${index + 1}`] = artwork;
            return acc;
          }, {});

          setTimeout(async () => {
            // Update quantity of custom artwork items and properties data
            await fetch(`${window.Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: dieSetupItemKey,
                quantity: artworksData.length,
                properties,
              }),
            })
              .then((response) => response.json())
              .then((data) => {
                const setupFeeItem = data.items.find((item) => item.id === dieSetupFeeId);
                if (setupFeeItem) {
                  // Forcing to refresh cart by running updateQuantity function with same data
                  cartItems?.updateQuantity(setupFeeItem?.key, setupFeeItem?.quantity);
                }
                cartItems?.enableCheckoutButton();
              })
              .catch((error) => {
                console.error('Error updating die setup fee quantity in cart', error);
              });
          }, 1000); // Timeout to make sure product is removed before removing setup fee
        }
      };

      // For Cart Drawer
      if ($itemModal) {
        const utils = SDG?.cartUtils() || {};
        utils?.initCartItemModal({
          modal: $itemModal,
          cb: async () => {
            await cartItems?.updateQuantity(this.dataset.index, 0);
            // Delete Die Setup Fee if only one custom artwork item left
            if (isCustomArtwork) {
              handleCustomArtwork();
            }
          },
        });
        return;
      }

      // For Cart page
      // Fallback if no modal or remove button found
      await cartItems.updateQuantity(this.dataset.index, 0);

      if (isCustomArtwork) {
        handleCustomArtwork();
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.config = {
      dom: {
        cart_item: '.js-cart-item',
        cart_item_acc: '.js-cart-item-acc',
        cart_checkout_button: 'CartDrawer-Checkout',
      },
    };
    this.cartItems = this.querySelectorAll(this.config.dom.cart_item) || [];
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });

    if (this.cartItems?.length > 0) {
      this.cartItems?.forEach((item) => {
        this.initAccordion(item);
      });
      this.updateCartItemsDeliveryMessage();
    }
    const utils = SDG?.cartUtils() || {};
    if (utils) {
      utils?.fetchGeoLoaction();
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value, 10);
    const { index } = event.target.dataset;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max, 10)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step, 10) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId,
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.cleanupDuplicateHeaders();
          if (this.cartItems?.length > 0) {
            this.cartItems?.forEach((item) => {
              this.initAccordion(item);
            });
          }
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.cleanupDuplicateHeaders();
          if (this.cartItems?.length > 0) {
            this.cartItems?.forEach((item) => {
              this.initAccordion(item);
            });
          }
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble-mobile',
        section: 'cart-icon-bubble-mobile',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  async updateQuantity(line, quantity, name, variantId) {
    const template = SDG?.Data?.template || null;
    this.enableLoading(line);

    const param = {
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    };

    // update function to accept item key
    if (line.length > 10) {
      param.id = line;
      param.line = null;
    }

    const body = JSON.stringify(param);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Server returned ${response.status}: ${response.statusText}`);
        }
        return response.text();
      })
      .then((state) => {
        let parsedState;
        try {
          parsedState = JSON.parse(state);
        } catch (e) {
          throw new Error(`Failed to parse server response: ${e.message}`);
        }

        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) {
            quantityElement.value = quantityElement.getAttribute('value');
          }

          this.updateLiveRegions(line, parsedState.errors);

          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = typeof parsedState.errors === 'string'
            ? parsedState.errors
            : window.cartStrings.error;

          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          if (section.id === 'main-cart-footer') {
            const htmlElement = new DOMParser().parseFromString(
              parsedState.sections[section.section],
              'text/html'
            );

            const newCartBlocks = htmlElement.querySelector('.cart__blocks');

            const existingCartBlocks = document.querySelector('.cart__blocks');

            if (newCartBlocks && existingCartBlocks) {
              existingCartBlocks.innerHTML = newCartBlocks.innerHTML;
            } else {
              console.warn('Could not find cart__blocks element in either the response or current DOM');

              const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
              const newElement = htmlElement.getElementById(section.id);

              if (elementToReplace && newElement) {
                elementToReplace.innerHTML = newElement.innerHTML;
              }
            }
          } else {
            const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
            if (!elementToReplace) {
              console.warn(`Element to replace with ID "${section.id}" was not found in the DOM`);
              return;
            }

            const htmlElement = new DOMParser().parseFromString(
              parsedState.sections[section.section],
              'text/html'
            );

            const newElement = htmlElement.getElementById(section.id);
            if (!newElement) {
              console.warn(`Element with ID "${section.id}" was not found in the response HTML`);
              return;
            }

            elementToReplace.innerHTML = newElement.innerHTML;
          }
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement?.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId });
      })
      .catch((error) => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');

        if (errors) {
          errors.textContent = `${window.cartStrings.error || 'Error updating cart'}. ${error.message || ''}`;
        }

        console.error('Cart update error:', error);
      })
      .finally(() => {
        if (line) this.disableLoading(line);

        if (template === 'cart') {
          this.cleanupDuplicateHeaders();
          this.initAccordion();
          this.updateCartItemsDeliveryMessage();
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) {
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

      // remove error message after 3 seconds
      setTimeout(() => {
        lineItemError.querySelector('.cart-item__error-text').innerHTML = '';
      }, 3000);
    }

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      if (cartStatus) cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');
    let item;
    if (line?.length > 10) {
      item = this.querySelector(`[data-item-key="${line}"]`);
    } else {
      item = this.querySelector(`#CartItem-${line}`) || this.querySelector(`#CartDrawer-Item-${line}`);
    }
    if (item) {
      const $cartItem = item.querySelector('.js-cart-item');
      if ($cartItem) $cartItem.classList.add('is-loading');
    }

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems') || null;
    if (!mainCartItems) return;

    mainCartItems.classList.remove('cart__items--disabled');
    let item;
    if (line?.length > 10) {
      item = this.querySelector(`[data-item-key="${line}"]`);
    } else {
      item = this.querySelector(`#CartItem-${line}`) || this.querySelector(`#CartDrawer-Item-${line}`);
    }
    if (item) {
      const $cartItem = item.querySelector('.js-cart-item');
      if ($cartItem) $cartItem.classList.remove('is-loading');
    }
  }

  enableCheckoutButton() {
    const checkoutButton = document.getElementById(this.config.dom.cart_checkout_button);
    if (checkoutButton) checkoutButton.disabled = false;
  }

  disableCheckoutButton() {
    const checkoutButton = document.getElementById(this.config.dom.cart_checkout_button);
    if (checkoutButton) checkoutButton.disabled = true;
  }

  initAccordion(line) {
    const template = SDG?.Data?.template || null;

    if (line instanceof HTMLElement) {
      const $acc = line.querySelector(this.config.dom.cart_item_acc) || null;
      const isInitialized = line.getAttribute('data-accordion-initialized') === 'true';

      if (!$acc || !$acc?.id || isInitialized) return;

      const accordionOptions = {
        dom: {
          id: $acc.id,
          btn: 'js-cart-item-acc-btn',
          menu: 'js-cart-item-acc-menu',
        },
        enable_linking: true,
      };
      const accordion = SDG?.accordion(accordionOptions);

      if (accordion) {
        accordion?.init();
        line.setAttribute('data-accordion-initialized', 'true');
      }
      return;
    }

    // fallback for cart items re-render
    if (template === 'cart') {
      this?.cartItems?.forEach((item) => {
        const $acc = item.querySelector(this.config.dom.cart_item_acc) || null;

        if (!$acc || !$acc?.id) return;

        const accordionOptions = {
          dom: {
            id: $acc.id,
            btn: 'js-cart-item-acc-btn',
            menu: 'js-cart-item-acc-menu',
          },
          enable_linking: true,
        };
        const accordion = SDG?.accordion(accordionOptions);

        if (accordion) {
          accordion?.init();
          item.setAttribute('data-accordion-initialized', 'true');
        }
      });
    }
  }

  async updateCartItemsDeliveryMessage() {
    try {
      const utils = SDG?.cartUtils() || {};

      if (utils) {
        utils?.getCartItemsDeliveryMessage();
      }
    } catch (err) {
      console.error({ message: 'Error fetching delivery data', error: err });
    }
  }

  cleanupDuplicateHeaders() {
    // Find all tbody elements
    const tbodies = this.querySelectorAll('tbody.js-contents');

    tbodies.forEach(tbody => {
      // Find any rows that contain th elements (header rows)
      const headerRows = tbody.querySelectorAll('tr:not([id]):has(th.cart-items__heading)');

      // Remove these duplicate header rows
      headerRows.forEach(row => {
        row.remove();
      });
    });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}
